import React from 'react'
import { Card, CardActionArea } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'

// MT.3: default elevation Card so it picks up the theme MuiCard override
// (radius['2xl'] + customShadows.card + border: none). The old
// variant='outlined' added a flat 1px border which didn't match the rest
// of the refreshed cards.
export const useStyles = makeStyles(({ spacing }) => ({
  body: {
    padding: spacing(2)
  }
}))

const ArticleCardContainer = ({ onSelect, article, children }) => {
  const classes = useStyles()
  return (
    <Card>
      <CardActionArea
        disabled={!article}
        onClick={() => onSelect(article)}
        className={classes.body}
        data-test={`article-container-${article?.friendlyUrl}`}
      >
        {children}
      </CardActionArea>
    </Card>
  )
}

export default ArticleCardContainer
